import React from "react";
import PropTypes from "prop-types";

import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";

// material-ui components
import withStyles from "material-ui/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import RegularCard from "components/Cards/RegularCard.jsx";

import contentPageStyle from "assets/jss/material-dashboard-pro-react/views/contentPageStyle.jsx";

class ContentPage extends React.Component {

  render() {
    const { classes, translate, page } = this.props;
    return (
      <div className={classes.content}>
        <div className={classes.container}>
          <GridContainer justify="center">
            <ItemGrid xs={12} sm={12} md={8}>        
                <RegularCard
                content={
                  <div>
                    <GridContainer>
                      <ItemGrid xs={12} sm={12}>
                        <h3>{translate("pages."+page+".title")}</h3>
                        <div dangerouslySetInnerHTML={{ __html: translate("pages."+page+".content") }} />
                      </ItemGrid>
                    </GridContainer>
                  </div>
                }
              />
              </ItemGrid>
              </GridContainer>
        </div>
      </div>
    );
  }
}

ContentPage.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state, props) => {
  return {
    page: props.location.pathname.replace("/","").replace(/-/g,"_"),
    translate: getTranslate(state.localize),
  }
}

export default compose(
  withStyles(contentPageStyle),
  connect(mapStateToProps, null)
)(ContentPage);


// WEBPACK FOOTER //
// ./src/views/Pages/ContentPage.jsx